import useSWR, { mutate, SWRConfiguration } from "swr"
import { APIError, api, formatAPIError } from "lib/api"

async function fetcher<ResponseDataType>(
  url: string
): Promise<ResponseDataType> {
  try {
    const response = await api(url)
    return response.json()
  } catch (error) {
    throw await formatAPIError(error)
  }
}

export function useApiData<ResponseDataType, ResponseErrorType = APIError>(
  endpoint?: string,
  options: SWRConfiguration<ResponseDataType, ResponseErrorType> = {}
) {
  return useSWR<ResponseDataType, ResponseErrorType>(
    endpoint || null,
    fetcher,
    {
      revalidateOnReconnect: true,
      refreshInterval: 0, // Do not poll
      shouldRetryOnError: true,
      dedupingInterval: 30000, // Fetch at most once every 30 seconds
      revalidateOnFocus: false,
      focusThrottleInterval: 30000,
      ...(typeof options === `object` ? options : {})
    }
  )
}

export function mutateApiData<MutationResponseType>(
  endpoint: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
): Promise<MutationResponseType> {
  return mutate(`/api/v1/${endpoint}`, data)
}
